// extracted by mini-css-extract-plugin
export default {"labelInfo":"sortable-dnd-item__label-info__HpSlM","listIcon":"sortable-dnd-item__list-icon__x2IQo"};